import { lazyOnNewMessageCompose } from 'owa-addins-core';
import { orchestrator } from 'satcheljs';
import { onComposeAddinsInitialized } from 'owa-mail-compose-actions';
import { isFeatureEnabled } from 'owa-feature-flags';

export default orchestrator(onComposeAddinsInitialized, actionMessage => {
    if (isFeatureEnabled('addin-autoRunAddins') && !actionMessage.itemId) {
        lazyOnNewMessageCompose.import().then(onNewMessageCompose => {
            onNewMessageCompose(actionMessage.hostItemIndex);
        });
    }
});
